// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UserDepartmentsTable_dropdown__H6Prz","checkbox":"UserDepartmentsTable_checkbox__3yisp"};